import * as Yup from "yup";

export const alphanumericWithOptionalDots = /^[A-Za-z]*\d+(\.\d+)?[A-Za-z]*$/;
export const levelSchema = Yup.string().matches(
  alphanumericWithOptionalDots,
  "Numbers, letters and dots only"
);
